import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  'font-bold cursor-pointer items-center justify-center p-4 text-lg gap-2 text-md focus:none',
  {
    variants: {
      variant: {
        default:
          'rounded-[18px] bg-default-button-gradient text-text-secondary disabled:text-text-secondary-disabled disabled:bg-bg-button-disabled',
        'border-gradient': 'bg-button-gradient text-text-brand-purple',
        dark: 'bg-white/10 text-white/80 hover:bg-white/20',
        gray: 'rounded-full bg-white/20 border border-white/25 text-white/40 font-bold',
        rainbow:
          'rounded-[16px] text-[#23262E] bg-rainbow-gradient text-[#23262E] border border-white/25 shadow-[0_10px_25px_0_rgba(254,217,173,0.25)] font-bold text-[18px] active:scale-95 disabled:pointer-events-none disabled:opacity-50',
        'dark-bordered': 'relative bg-dark-button text-white font-bold overflow-hidden rounded-[16px]',
        'dark-bordered-fully-rounded':
          'relative bg-dark-button-fully-rounded text-white font-bold overflow-hidden rounded-full',
      },
      size: {
        xs: 'px-2 h-8 py-0',
        inline: 'inline-flex',
        'full-width': 'flex w-full',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'full-width',
    },
  },
);
